<template>
  <div class="search-content-wrap" shadow="always" style="padding:20px;">
    <div class="">
      <div class="title_left" v-if="lang == 'ch'">{{exhObject.exh_name}}</div>
      <div class="title_left" v-else>{{exhObject.exh_name_en}}</div>
    </div>
    <div class="searchContent-wrap">
      <div class="card_content_left">
        <div class="card_content_left_wrap">
          <div class="card_content_left_wrap_flex1">
            <img src="../../assets/index-timer.png" alt="">
          </div>
          <div class="card_content_left_wrap_flex2">
            <div class="card_content_left_wrap_flex2-begtime">
              <p v-if="lang == 'ch'">开始时间</p>
              <p v-else>Start Time</p>
              <p>{{exhObject.exh_begtime}}</p>
            </div>
            <div class="card_content_left_wrap_flex2-endtime">
              <p v-if="lang == 'ch'">结束时间</p>
              <p v-else>End Time</p>
              <p>{{exhObject.exh_endtime}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card_content">
        <div class="card_content-left">
          <div class="angle"></div>
          <img v-if="lang=='ch'" :src="exhObject.exh_share_pic || exhObject.exh_share_pic_en" alt="">
          <img v-if="lang=='en'" :src="exhObject.exh_share_pic_en || exhObject.exh_share_pic" alt="">
        </div>
        <div class="card_content-right">
          <div class="content_title_wrap">
            <div class="content_title pointer" @click="handleRoom">
              <!-- <div class="title_left" v-if="lang == 'ch'">{{exhObject.exh_name}}</div>
              <div class="title_left" v-else>{{exhObject.exh_name_en}}</div> -->
              <!--展会状态-->
              <div
                class="title_right"
                :class="exhObject.exh_type == ExhibitionTypeEnum.HAS_ENDED ||
                    exhObject.exh_type == ExhibitionTypeEnum.END_HAS_ENDED ? 'state': 'carry' "
                :style="{width: (lang == 'ch' ? '' : '130px')}"
                v-if="exhObject.exh_type_text == '' &&
                    exhObject.exh_type != 1&&
                    exhObject.exh_type != 6
                      "
              >
                {{exhObject.exh_type | stateText(ExhibitionType)}}
                <div class="wrap" v-if="exhObject.exh_type == ExhibitionTypeEnum.ONGOING">
                  <ul class="animation">
                    <li class="animation_one"></li>
                    <li class="animation_two"></li>
                    <li class="animation_three"></li>
                  </ul>
                </div>
              </div>
              <!--展会剩余天数-->
              <div class="title_day" v-else-if="exhObject.exh_day_hour > 0">
                {{language.cluesTime1}}
                <div
                  class="title_span"
                  :class="exhObject.exh_type_text >= 5 ? 'moreThanFive': 'lessThanFive' "
                >{{exhObject.exh_type_text}}</div>
                {{language.cluesTime2}}
                <div
                  class="title_span"
                  :class="exhObject.exh_type_text >= 5 ? 'moreThanFive': 'lessThanFive' "
                >{{exhObject.exh_time_hour}}</div>
                {{language.cluesTime3}}
              </div>
            </div>
          </div>
          <!-- <div
            class="content_time pointer"
            @click="handleRoom"
          >{{language.exhibitionTime}}: {{exhObject.exh_begtime}} —— {{exhObject.exh_endtime}}</div> -->
          <div class="textbtn-wrap">
            <div class="content_introduce pointer" @click="handleRoom">
              <p style="text-indent:2em;" v-if="lang == 'ch'"  v-html="exhObject.exh_introduce">{{exhObject.exh_introduce}}</p>
              <p style="text-indent:2em;" v-else  v-html="exhObject.exh_introduce_en">{{exhObject.exh_introduce_en}}</p>
            </div>
            <div class="content_btn">
              <div class="content_btn_wrap">
                
                <!-- 线上 exhObject.exhibition_id != 29 && (exhObject.is_free != 1 || !token)-->

                <!--我要报名-->
                <el-button
                  type="primary"
                  class="btn"
                  style="background: linear-gradient(0deg, rgb(0, 180, 251),  rgb(0, 104, 234));border: none;cursor: pointer"
                  @click="handleRegister"
                  v-if="exhObject.exh_type!=3 && exhObject.exhibition_id != 29 && exhObject.ExhEndtime > ((new Date()).getTime()/1000)"
                >
                <img src="../../assets/icon-index-btn-bm.png" alt="">
                {{language.exhibitionSignup}}
                </el-button>
                
                <el-button
                  type="primary"
                  class="btn"
                  style="background: linear-gradient(0deg, rgb(0, 180, 251),  rgb(0, 104, 234));border: none;cursor: pointer;margin-left:50px;"
                  @click="handleRegister"
                  v-if="exhObject.exh_type!=3 && exhObject.exhibition_id != 29  && exhObject.ExhEndtime > ((new Date()).getTime()/1000)"
                >
                <img src="../../assets/icon-index-btn-pay.png" alt="">
                {{language.exhibitionPay}}
                </el-button>

                <el-button
                  type="warning"
                  class="btn-join"
                  @click="handleRoom"
                  style="background: linear-gradient(0deg, rgb(236, 141, 55), rgb(239, 106, 40));border: none;cursor: pointer;margin-left: 50px"
                >
                  <img src="../../assets/icon-index-btn-join.png" alt="">
                  <span>{{language.joinVenue}}</span>
                </el-button>
                <!--我要观展 buyType : 1-->
                <!-- <el-button
                  type="primary"
                  class="btn"
                  style="background: #0f408a;border: none;cursor: pointer"
                  @click="handleWatch"
                  v-if="
                            ExhibitionTypeEnum.HAS_ENDED != exhObject.exh_type &&
                            loginType.LOGIN_TICKET != userInfo.logintype &&
                            ExhibitionTypeEnum.END_HAS_ENDED != exhObject.exh_type
                            "
                >{{language.exhibitionVisit}}</el-button> -->
                <!--我要参展 buyType : 2 -->
                <!-- <el-button
                  type="primary"
                  class="btn"
                  style="background: #0f408a;border: none;cursor: pointer"
                  @click="handleJoin"
                  v-if="
                            ExhibitionTypeEnum.HAS_ENDED != exhObject.exh_type &&
                            loginType.LOGIN_TICKET != userInfo.logintype &&
                            ExhibitionTypeEnum.END_HAS_ENDED != exhObject.exh_type
                            "
                >{{language.participation}}</el-button> -->
              
              <!--我要支付-->
              
                <!-- v-if="
                            ExhibitionTypeEnum.HAS_ENDED != exhObject.exh_type &&
                            loginType.LOGIN_TICKET != userInfo.logintype &&
                            ExhibitionTypeEnum.END_HAS_ENDED != exhObject.exh_type
                            " -->
              </div>
            </div>
          </div>
         
        </div>
       
      </div>
    </div>
    <div v:if="indexfilepath!='' "  style="width:100%;margin-top:40px;"><img :src="exhObject.file_path" alt="" style="width:100%;height:auto;border-radius:10px;"></div>
  </div>
  
</template>

<script>
import {
  ExhibitionType,
  ExhibitionTypeEnum,
  ExhibitionHandleEnum,
  loginType
} from "../../common/constant/exhibition";
import { mapGetters } from "vuex";
export default {
  props: {
    language: {
      type: Object,
      default: () => {}
    },
    exhObject: {
      type: Object,
      default: () => {}
    },
    lang: {
      type: String
    },
    exhIndex: {
      type: String
    }
  },
  data() {
    return {
      ExhibitionType,
      ExhibitionTypeEnum,
      ExhibitionHandleEnum,
      loginType
    };
  },
  methods: {
    //参展
    handleJoin() {
      this.$emit(
        "join-activities",
        this.ExhibitionHandleEnum.JOIN_EXH,
        this.exhObject.exhibition_id
      );
    },
    //观展
    handleWatch() {
      this.$emit(
        "join-activities",
        this.ExhibitionHandleEnum.VIEW_EXH,
        this.exhObject.exhibition_id
      );
    },
    //进入会场
    handleRoom() {
      this.$emit(
        "join-activities",
        this.ExhibitionHandleEnum.ENTER_ROOM,
        this.exhObject.exhibition_id
      );
    },
    //我要支付
    handleRegister() {
      this.$emit(
        "join-handleRegister",
        this.ExhibitionHandleEnum.BUY_TICKET,
        this.exhObject.exhibition_id
      );
    },
  

  },
  computed: {
    ...mapGetters(["token","userInfo"])
  }
};
</script>

<style lang="css" scoped>
.pointer {
  cursor: pointer;
}

/* .home-secondtongAd{
  height:170px;
  width:1200px;
  position:absolute;
  left:0;
  bottom:300px;
}

.home-secondtongAd img{
  width:100%;
  height:100%;
} */
.card_not_data {
  font-size: 20px;
  text-align: center;
  line-height: 232px;
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
}
.searchContent-wrap{
  display: flex;
  font-size: 16px;
  color: #fff;
}
.card_content_left{
  padding-top: 25px;
  /* flex: 1; */
}
.card_content_left_wrap{
  /* display: flex; */
}
.card_content_left_wrap_flex1{
  /* flex: 1; */
  float: left;
}
.card_content_left_wrap_flex1 img{
  width: 25px;
  height: auto;
  padding-top: 10px;
  padding-right: 10px;
}
.card_content_left_wrap_flex2{
  /* flex: 1; */
  max-width: 150px;
}
.card_content_left_wrap_flex2-begtime{
  margin: -10px 35px 58px 10px;
  line-height: 21px;
  /* margin-top: -10px; */
}
.card_content_left_wrap_flex2-endtime{
  margin: 58px 35px 0px 10px;
  line-height: 21px;
  /* margin-top: -10px; */
}

.card_content {
  /* flex: 4; */
  /* display: flex; */
  /* display: -webkit-flex; */
  flex-direction: column;
}

.search-content-wrap{
  position:relative;
}
.search-content-wrap:nth-child(2n) .card_content-left{
  position: relative;
  padding: 20px;
  float: right;
  width: 340px;
  height: 210px;
  background: white;
  margin: 0 !important;
  border: 0 !important;
}
.card_content-left{
  position: relative;
  padding: 20px;
  float: left;
  width: 340px;
  height: 210px;
  background: white;
}
.card_content-left .angle {
  position: absolute;
  top: 0px;
  right: -30px;
  width: 0;
  height: 0;
  border-bottom: 40px solid #f4f4f4;
  border-right: 30px solid transparent;
}

.search-content-wrap:nth-child(2n) .card_content-left .angle{
  position: absolute;
  top:0px;
  left: -30px;
  width: 0;
  height: 0;
  border-bottom: 40px solid #f4f4f4;
  border-left: 30px solid transparent;
  border-right: 0px solid transparent;
}
.card_content-left img{
  width: 100%;
  height: 100%;
}
.card_content-right{
  position: relative;
  padding-top: 40px;
  float: left;
  width: 630px;
}
/* .search-content-wrap:nth-child(2n) >>> .card_content-right{
  margin-left: 2px;
} */
.search-content-wrap:nth-child(2n)  .content_title_wrap{
  position: absolute;
  top: -45px;
  right: -330px;
}
.content_title_wrap{
  position: absolute;
  top: -5px;
  right: 50px;
  
}
.textbtn-wrap{
  width: 100%;
  height: 210px;
  background-image: linear-gradient(to left, white , #f9f9f9);
}
.search-content-wrap:nth-child(2n)  .textbtn-wrap{
  background-image: linear-gradient(to right, white , #f9f9f9);
}
.content_title {
  float: right;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
.content_btn {
  /* display: flex;
  display: -webkit-flex;
  flex-direction: row-reverse; */
  margin: 0 auto;
}
.content_btn_wrap{
  margin: 5px auto 0;
  text-align: center;
}
.title_left {
  width: 70%;
  font-family: MicrosoftYaHei;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  /* line-height: 17px; */
  letter-spacing: 0;
  color: #fff;
  margin: 0 0 15px 0;
}
.content_time {
  font-family: MicrosoftYaHeiLight;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 17px;
  letter-spacing: 0;
  color: #424242;
  padding: 20px 0 15px 0;
}
.content_introduce {
  color: #000;
  font-family: MicrosoftYaHeiLight;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  padding: 30px 40px;
  height: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;  /* 超出n行这里写n */
  -webkit-box-orient: vertical;
  margin-bottom: 10px;
}
.btn {
  /* width: 100px; */
  height: 40px;
  /* margin-top: 50px; */
}
.btn img{
  width: 20px;
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 10px;
}
.btn span{
  padding-top: 5px;
}
.btn-join{
  /* width: 100px; */
  height: 40px;
  /* padding-top: 3px; */
}
.btn-join img{
  width: 20px;
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 10px;
}
.btn-join span{
  padding-top: 5px;
}
.title_span {
  /* width: 35px;
  height: 29px; */
  line-height: 29px;
  border-radius: 4px;
  font-size: 20px;
  display: inline-block;
  text-align: center;
  /* margin: 0 10px; */
}
.lessThanFive {
  color: #f47900;
  font-size: 35px;
  font-weight: bold;
}
.moreThanFive {
  font-size: 50px;
  padding-left: 5px;
  padding-right: 5px ;
  /* border: 1px solid #f47900; */
  color: #f47900;
  margin-bottom: -5px;
}
.title_right {
  font-size: 20px;
  line-height: 26px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.state {
  width: 74px;
  height: 26px;
  color: #a1a1a1;
  background-color: #e6e6e6;
}
.title_day {
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  margin-top: -10px;
}
.carry {
  width: 100px;
  height: 29px;
  border-radius: 4px;
  border: solid 1px #f47900;
  color: #f47900;
  position: relative;
}

.wrap ul {
  position: absolute;
  display: inline-block;
  vertical-align: center;
  right: 6px;
  top: 23px;
  transform: translateY(-50%);
  font-size: 0;
}
.wrap ul li {
  background-color: #f47900;
  display: inline-block;
  margin-left: 2px;
  width: 2px;
  height: 15px;
}
.animation_one {
  -webkit-animation: 0.8s 0.1s living linear infinite backwards normal;
  animation: 0.8s 0.1s living linear infinite backwards normal;
  -webkit-animation-delay: -1.1s;
}
.animation_two {
  -webkit-animation: 0.8s 0.3s living linear infinite backwards normal;
  animation: 0.8s 0.3s living linear infinite backwards normal;
  -webkit-animation-delay: -1.3s;
}
.animation_three {
  -webkit-animation: 0.8s 0.6s living linear infinite backwards normal;
  animation: 0.8s 0.6s living linear infinite backwards normal;
  -webkit-animation-delay: -1.6s;
}
@-webkit-keyframes living {
  0% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
  50% {
    -webkit-transform: scaleY(0.3);
    transform: scaleY(0.3);
    -webkit-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
  100% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
}
@keyframes living {
  0% {
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 0 120px;
    -ms-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
  50% {
    -webkit-transform: scaleY(0.3);
    -ms-transform: scaleY(0.3);
    transform: scaleY(0.3);
    -webkit-transform-origin: 0 120px;
    -ms-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
  100% {
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 0 120px;
    -ms-transform-origin: 0 120px;
    transform-origin: 0 5px;
  }
}
</style>
